import { plural } from 'lib/plural';
import React from 'react';
import { getDomainRestrictionsForItems } from 'reactApp/appHelpers/appHelpers';
import { moveRequest } from 'reactApp/modules/modifying/modifying.actions';
import { showSnackbarAction } from 'reactApp/modules/snackbar/snackbar.actions';
import { SnackbarTypes } from 'reactApp/modules/snackbar/snackbar.types';
import { isReadOnlyMountedOrShared, isSharedOrMountedStatus } from 'reactApp/modules/storage/storage.selectors';
import { store as reduxStore } from 'reactApp/store';
import { sendDwh } from 'reactApp/utils/ga';
import { noop } from 'reactApp/utils/helpers';

const { renderComfirmationDialog } = process.env.SSR
    ? ({} as any)
    : require('reactApp/components/BaseConfirmDialog/BaseConfirmDialog.helpers');

export const moveItemsDialog = (items, destination) => {
    if (!items || !destination) {
        return;
    }

    const { isDomainAndDeleteRestricted } = getDomainRestrictionsForItems(items);
    if (isDomainAndDeleteRestricted) {
        reduxStore.dispatch(
            showSnackbarAction({
                id: 'upload-error',
                text: 'У вас нет прав для создания, загрузки и перемещения файлов в эту папку',
                type: SnackbarTypes.failure,
                closable: true,
            })
        );
        return;
    }

    const isSharedOrMounted = isSharedOrMountedStatus(reduxStore.getState(), destination);
    const count = {
        folders: items.filter((item) => item.isFolder).length,
        files: 0,
    };
    count.files = items.length - count.folders;

    let text = '';
    if (items.length === 1) {
        text = `${count.folders ? 'папку' : 'файл'} «${items[0].name}»`;
    } else {
        let foldersText = '';
        if (count.folders) {
            foldersText = `${count.folders} ${['выбранную', 'выбранные', 'выбранных'][plural(count.folders)]} ${
                ['папку', 'папки', 'папок'][plural(count.folders)]
            }`;
        }
        const and = count.files && count.folders ? ' и ' : '';
        let filesText = '';
        if (count.files) {
            filesText = `${count.files} ${count.folders ? '' : ['выбранный', 'выбранных', 'выбранных'][plural(count.folders)]} ${
                ['файл', 'файла', 'файлов'][plural(count.files)]
            }`;
        }
        text = `${foldersText}${and}${filesText}`;
    }

    renderComfirmationDialog({
        dataQAId: 'move-files-confirmation-dialog',
        renderHeader: () => 'Перемещение',
        successButtonText: 'Переместить',
        renderContent: () => (
            <>
                <div style={{ overflowWrap: 'break-word' }}>{`Переместить ${text} в папку «${destination.name}»?`}</div>
                {isSharedOrMounted && (
                    <div style={{ overflowWrap: 'break-word', marginTop: '16px', fontWeight: 'normal' }} data-name="alert-text">
                        После переноса файлы будут доступны всем, у кого есть доступ к этой папке.
                    </div>
                )}
            </>
        ),
        onSuccess: () => {
            sendDwh({
                eventCategory: 'move',
                p: 'cloud-web-analytics',
                action: 'move',
                dwh_enabled: true,
                dwhData: { from: isSharedOrMounted ? 'common' : '' },
            });

            reduxStore.dispatch(moveRequest({ items, destination: destination.id }));
        },
        onClose: noop,
    });
};

export const isReadOnly = (item) => isReadOnlyMountedOrShared(reduxStore.getState(), item);
